<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 商品中心->公共套餐 -->
    <div class="main2" style="margin-top:-5px;">
      <!--<div class="title">{{ obj.name }}</div>-->
      <div v-if="!isShow" class="main2">
        <div class="bottom">
          <el-table
            v-if="aryList.length > 0"
            :data="aryList"
            style="width: 100%;border-left:1px solid #e7e6e4;border-right:1px solid #e7e6e4"
            :cell-style="{
              	'text-align':'center',
              	'border-color':'#dbdbdb',
              	'position':'relative',
                  'background-color': '#fff',
              	'border-right':'1px solid #e7e6e4'
            }"
            :header-cell-style="{
                  'background-color': '#e5e4e2',
                  'color': '#000',
              	'fontSize':'14px',
              	'fontWeight':'300',
              	'text-align':'center'
            }"
          >
            <el-table-column prop="articleTitle" label="标题">
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  type="primary"
                  @click="showInfo(scope.row)"
                  >{{ scope.row.articleTitle }}</el-link
                >
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="发布时间">
            </el-table-column>
          </el-table>
          <div class="none" v-if="aryList.length <= 0">
            暂无{{ obj.name }}
          </div>
        </div>
        <br />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
		<el-button size="mini" style="display:inline-block;">GO</el-button>
      </div>
      <div v-if="isShow" class="main2 borderShadow">
		<div class="help-title">{{ form.articleTitle }}</div>
        <div class="help-main" v-html="form.articleContent"></div>
        <div class="help-body">
          <el-link :underline="false" type="primary" 
		  style="position:absolute;left:20px;bottom:25px;font-size:16px;"
		  @click="closeShow()"
            >返回列表</el-link>
			{{ form.createTime }}
        </div>
      </div>
    </div>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { getArticleListRequest } from "../../../public/js/service";

export default {
  props: ["obj"],
  data() {
    // 1.data
    return {
      totalPages: 1,
      pageNum: 1,
      total: 1,
      pageSize: 10,
      aryList: [],
      token: "", // 1.6.token
      formLabelWidth: "120px",
      editShow: false,
      editTitle: "添加组合",
      isShow: false,
      showIndex: null,
      form: {},
    };
  },

  components: {
  },

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },
  
    getList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        articleTypeId: this.obj.articleTypeId,
      };

      getArticleListRequest(data).then((res) => {
        this.aryList = res.data.map((item, index) => {
          item.index = index;
          return item;
        });

        this.total = res.totals || 1;
        this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;

        if (this.aryList.length == 1) {
          this.showInfo(this.aryList[0]);
        } else {
          this.isShow = false;
        }
      });
    },
    loadShow(row) {
      console.log(row);
      if (localStorage.token) {
        this.token = localStorage.token;
        this.getList();
      }
    },
    showInfo(row) {
      console.log(row);
      this.isShow = true;
      this.form = row;
    },
    closeShow() {
      this.isShow = false;
    },
  },
  watch: {
    obj: function(val) {
      console.log(val);
      if (localStorage.token) {
        this.token = localStorage.token;
        this.getList();
      }
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getList();
    }
  },
};
</script>
